import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from '../i18n';

const PAGE_KEYS = { catalogue: 'catalogue', vendre: 'vendre', blog: 'blog', padpro: 'padpro', login: 'login', register: 'login' };

const setLinkTag = (rel, hreflang, href) => {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    else el.setAttribute('data-seolang', '1');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const SeoLang = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language || 'fr';
    document.documentElement.setAttribute('lang', lang);

    const seg = pathname.split('/').filter(Boolean)[0] || '';
    const key = PAGE_KEYS[seg] || 'default';
    document.title = t(`seo.${key}.title`);
    let meta = document.head.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', t(`seo.${key}.description`));

    const origin = 'https://www.padsmash.com';
    SUPPORTED_LANGS.forEach((l) => {
      const prefix = l === 'fr' ? '' : `/${l}`;
      setLinkTag('alternate', l, `${origin}${prefix}${pathname}`);
    });
    setLinkTag('alternate', 'x-default', `${origin}${pathname}`);
    const canonicalPrefix = lang === 'fr' ? '' : `/${lang}`;
    setLinkTag('canonical', null, `${origin}${canonicalPrefix}${pathname}`);

    const OG_LOCALES = { fr: 'fr_FR', en: 'en_GB', es: 'es_ES', it: 'it_IT' };
    const setMetaProp = (prop, content) => {
      let m = document.head.querySelector(`meta[property="${prop}"]`);
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('property', prop);
        document.head.appendChild(m);
      }
      m.setAttribute('content', content);
    };
    setMetaProp('og:locale', OG_LOCALES[lang] || 'fr_FR');
    setMetaProp('og:url', `${origin}${canonicalPrefix}${pathname}`);
  }, [pathname, t, i18n.language]);

  return null;
};
